import {
    api_url,
    legendLabelsBoxHeightLine,
    configChartsColorPalettes,
    yRight,
    partMobilityIndicators,
    popupInformation,
    defaultBarPercentage,
    defaultCategoryPercentage,
    defaultDatalabelsProperties,
    defaultTicksCustomValue,
    defaultDatalabelsAnchor,
    defaultDatalabelsAlign,
} from "../../../utils";

const VehiculeAutomoteur = {
    checked: false,
    titleSideBar: "Mobility Indicators Content.indicators.VehiculeAutomoteur",
    titleIndicator: "Mobility Indicators Content.indicators.VehiculeAutomoteur",
    popupInformation: {
        status: "false",
        text: popupInformation[partMobilityIndicators]["vehiculeAutomoteur"],
    },
    keyFigure: {
        typeUpdate: "year", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
    },
    charts: [
        {
            typeChart: "picto",
            typeLabels: "geographical_areas", // years or geographical_areas
            multiYearGeographicalArea: true,
            singleYearGeographicalAreaType: "year", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
            titleChart: "",
            titleDisplay: "true",
            legendDisplay: "false",
            legendCustom: "false",
            legendLabelsBoxHeight: legendLabelsBoxHeightLine,
            maintainAspectRatio: false,
            indexAxis: "x", // x or y
            heightChart: "250",
            widthChart: "600",
            scales: {
                x: {
                    type: undefined,
                    display: true,
                    stacked: false,
                    titleDisplay: false,
                    titleText: "",
                    gridDisplay: false,
                    beginAtZero: false,
                    ticks: {
                        display: false,
                        value: defaultTicksCustomValue,
                    },
                },
                y: {
                    type: undefined,
                    display: true,
                    stacked: false,
                    titleDisplay: true,
                    titleText: "",
                    gridDisplay: false,
                    beginAtZero: false,
                    max: null,
                    ticks: {
                        display: false,
                        value: defaultTicksCustomValue,
                    },
                },
                yRight: yRight,
            },
            annotationsProperties: {
                annotation1: undefined,
                annotation2: undefined,
            },
            keyFigure: {
                typeUpdate: "geographical_area", // year or geographical_area
                label: "",
                url: "",
                separator: "thousand",
                position: "",
            },
            datasets: [
                {
                    type: "picto-simple",
                    label: "Mobility Indicators Content.charts.VehiculeAutomoteur.legend.Autos : REPLACEPICTOKEYFIGURE",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=mobility-indicators&type_label=cusco_geographical_areas&indicator=vehicule_automoteur&trend=projection&chart=vehicule_automoteur_autos&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes["0"].backgroundColor,
                    borderColor: configChartsColorPalettes["0"].borderColor,
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: defaultCategoryPercentage,
                    datalabelsProperties: defaultDatalabelsProperties,
                    pictoProperties: {
                        cssClassIcon:
                            "dashboard-picto-car-80px filter-area-metropolitana-A0778E",
                    },
                },
                {
                    type: "picto-simple",
                    label: "Mobility Indicators Content.charts.VehiculeAutomoteur.legend.Motos : REPLACEPICTOKEYFIGURE ",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=mobility-indicators&type_label=cusco_geographical_areas&indicator=vehicule_automoteur&trend=projection&chart=vehicule_automoteur_motos&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes["0"].backgroundColor,
                    borderColor: configChartsColorPalettes["0"].borderColor,
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: defaultCategoryPercentage,
                    datalabelsProperties: defaultDatalabelsProperties,
                    pictoProperties: {
                        cssClassIcon:
                            "dashboard-picto-moto-80px-png filter-area-metropolitana-A0778E",
                    },
                },
                {
                    type: "picto-simple",
                    label: "Mobility Indicators Content.charts.VehiculeAutomoteur.legend.Taxis ilegales : REPLACEPICTOKEYFIGURE  ",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=mobility-indicators&type_label=cusco_geographical_areas&indicator=vehicule_automoteur&trend=projection&chart=vehicule_automoteur_taxis_ilegales&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes["0"].backgroundColor,
                    borderColor: configChartsColorPalettes["0"].borderColor,
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: defaultCategoryPercentage,
                    datalabelsProperties: defaultDatalabelsProperties,
                    pictoProperties: {
                        cssClassIcon:
                            "dashboard-picto-taxis-ilegales-png filter-area-metropolitana-A0778E",
                    },
                },
                {
                    type: "picto-simple",
                    label: "Mobility Indicators Content.charts.VehiculeAutomoteur.legend.Taxis legales : REPLACEPICTOKEYFIGURE   ",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=mobility-indicators&type_label=cusco_geographical_areas&indicator=vehicule_automoteur&trend=projection&chart=vehicule_automoteur_taxis_legales&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes["0"].backgroundColor,
                    borderColor: configChartsColorPalettes["0"].borderColor,
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: defaultCategoryPercentage,
                    datalabelsProperties: defaultDatalabelsProperties,
                    pictoProperties: {
                        cssClassIcon:
                            "dashboard-picto-taxis-legales-png filter-area-metropolitana-A0778E",
                    },
                },
            ],
        },
    ],
};

export default VehiculeAutomoteur;
